import axios from "axios";
import { API_BASE_URL } from "../constants";

const submitFeedback = async (feedback, accessToken) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/process-feedback`, {
      feedback,
    }, {
      headers: {
      'Authorization': `Bearer ${accessToken}`
      }
    });
    return response.data;
  } catch (error) {
    throw new Error("Error submitting feedback, please try again.");
  }
};

export { submitFeedback };
